"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sections = exports.HeadingWrapper = exports.Header = exports.Footer = exports.FilterFlyout = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Paragraph = require("@vfuk/core-paragraph/dist/styles/Paragraph.style");

var _Heading = require("@vfuk/core-heading/dist/styles/Heading.style");

var _Pill = require("@vfuk/core-pill/dist/styles/Pill.style");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var FilterFlyout = _styledComponents["default"].div.withConfig({
  displayName: "FilterFlyoutstyle__FilterFlyout",
  componentId: "sc-zn1zfj-0"
})(function () {
  return (0, _styledComponents.css)(["display:flex;flex-direction:column;height:100vh;max-height:100%;"]);
});

exports.FilterFlyout = FilterFlyout;

var Header = _styledComponents["default"].div.withConfig({
  displayName: "FilterFlyoutstyle__Header",
  componentId: "sc-zn1zfj-1"
})(function (props) {
  return (0, _styledComponents.css)(["", ";display:flex;flex-direction:column;border-bottom:", " ", " ", ";> ", "{", ";}"], props.theme.mixins.spacing('padding-bottom', 3), props.theme.border.width[1], props.theme.border.style[1], props.theme.color.monochrome3["default"], _Paragraph.Paragraph, props.theme.mixins.advancedSpacing('padding', [0, 5]));
});

exports.Header = Header;

var HeadingWrapper = _styledComponents["default"].div.withConfig({
  displayName: "FilterFlyoutstyle__HeadingWrapper",
  componentId: "sc-zn1zfj-2"
})(function (props) {
  return (0, _styledComponents.css)(["display:flex;", " > ", "{", ";}> ", "{align-self:center;}"], props.hasSubText && (0, _styledComponents.css)(["", ";"], props.theme.mixins.spacing('padding-bottom', 3)), _Heading.Heading, props.theme.mixins.spacing('margin-right', 3), _Pill.Pill);
});

exports.HeadingWrapper = HeadingWrapper;

var Sections = _styledComponents["default"].div.withConfig({
  displayName: "FilterFlyoutstyle__Sections",
  componentId: "sc-zn1zfj-3"
})(function (props) {
  return (0, _styledComponents.css)(["display:flex;flex-direction:column;position:relative;overflow:auto;", ";> div{", ";border-bottom:", " ", " ", ";&:first-child{padding-top:0;}&:last-child{border-bottom:none;}}"], props.theme.mixins.advancedSpacing('padding', [3, 5]), props.theme.mixins.advancedSpacing('padding', [3, 0]), props.theme.border.width[1], props.theme.border.style[1], props.theme.color.monochrome3["default"]);
});

exports.Sections = Sections;

var Footer = _styledComponents["default"].div.withConfig({
  displayName: "FilterFlyoutstyle__Footer",
  componentId: "sc-zn1zfj-4"
})(function (props) {
  return (0, _styledComponents.css)(["background-color:", ";display:flex;position:relative;", ";", ";", ";flex:1;"], props.theme.color.monochrome2["default"], props.theme.mixins.advancedSpacing('margin', [10, -5, 0]), props.theme.mixins.spacing('padding', 5), props.theme.mixins.spacing('gap', 3));
});

exports.Footer = Footer;
//# sourceMappingURL=FilterFlyout.style.js.map